/**
 * Created by Denis Kuzin on 10 november 2022
 */

const CustomerRecipe = function (recipeTemplate) {
    this.index = recipeTemplate.index;
    this.code = recipeTemplate.code;
    this.level = recipeTemplate.level;
    if (recipeTemplate.order) {
        this.onlyWhenNeeded = CustomerRecipe.isOrderProduceOnlyWhenNeeded(recipeTemplate.order);
    }
    this.setIngredients(recipeTemplate.ingredients);
    this.order = CustomerRecipe.chooseIngredients(recipeTemplate.order || recipeTemplate.bonus);
    this.cooking = false;

    if (recipeTemplate.cookingDuration) {
        this.cookingDuration = cleverapps.parseInterval(recipeTemplate.cookingDuration);
    }
};

CustomerRecipe.prototype.listPrize = function (unissuedPrizesQuantity) {
    const prizes = [];

    this.order.forEach((item) => {
        if (item.unit) {
            for (let i = 0; i < item.amount; i++) {
                prizes.push(item.unit);
            }
        } else if (item.ingredient) {
            prizes.push(item);
        }
    });

    if (unissuedPrizesQuantity && prizes.length > unissuedPrizesQuantity) {
        prizes.length = unissuedPrizesQuantity;
    }

    return prizes;
};

CustomerRecipe.prototype.calcIngredients = function () {
    return this.ingredients.length;
};

CustomerRecipe.prototype.prizesToRewards = function () {
    const rewards = {};

    this.listPrize().forEach((prize) => {
        if (prize.ingredient) {
            rewards[prize.ingredient] = prize.amount;
        } else if (prize.code !== undefined && prize.stage !== undefined) {
            if (!rewards["units"]) {
                rewards["units"] = [];
            }

            const unit = rewards["units"].find((u) => u.code === prize.code && u.stage === prize.stage);
            if (unit) {
                unit.amount++;
            } else {
                rewards["units"].push({
                    code: prize.code,
                    stage: prize.stage,
                    amount: 1
                });
            }
        }
    });

    return rewards;
};

CustomerRecipe.prototype.isEnoughIngredients = function () {
    return this.ingredients.every((ingredient) => Map2d.currentMap.stock.getLackingAmount(ingredient) === 0);
};

CustomerRecipe.prototype.getIngredients = function () {
    return this.ingredients;
};

CustomerRecipe.prototype.getOrder = function () {
    return this.order;
};

CustomerRecipe.prototype.isOrderValid = function () {
    let result = true;
    if (this.onlyWhenNeeded) {
        result = Boolean(this.order.some((ingredient) => {
            const amount = Map2d.currentMap.customers.requiredIngredientAmount(ingredient);
            return amount && Map2d.currentMap.stock.getStockAmount(ingredient) < amount;
        }));
    }
    return result;
};

CustomerRecipe.prototype.getCookingDuration = function () {
    return this.cookingDuration || 0;
};

CustomerRecipe.prototype.setIngredients = function (ingredients) {
    this.ingredients = CustomerRecipe.chooseIngredients(ingredients);
};

CustomerRecipe.prototype.setCookingDuration = function (duration) {
    this.cookingDuration = duration;
};

CustomerRecipe.prototype.getShoppingList = function () {
    const shoppingList = {
        hardItems: [], softItems: [], totalUnits: 0, totalHard: 0, totalSoft: 0
    };
    this.getIngredients().forEach((ingredient) => {
        const amount = Map2d.currentMap.stock.getLackingAmount(ingredient);
        const price = this.calcIngredientPrice(ingredient);
        ingredient = cleverapps.clone(ingredient);
        ingredient.amount = amount;
        const disablePurchase = ingredient.unit && ingredient.unit.customInfo && ingredient.unit.customInfo.disablePurchase;
        if (amount && !disablePurchase) {
            if (price.currency === "soft") {
                shoppingList.softItems.push(ingredient);
                shoppingList.totalSoft += amount * price.price;
            } else {
                shoppingList.hardItems.push(ingredient);
                shoppingList.totalHard += amount * price.price;
            }
        }
    });
    return shoppingList;
};

CustomerRecipe.prototype.calcIngredientPrice = function (ingredient) {
    let currency = "hard";
    let price = 0;

    if (ingredient.unit && ["searesource", "rpresource", "drresource"].indexOf(Families[ingredient.unit.code].type) !== -1) {
        currency = "soft";
    }

    if (!cleverapps.meta.getSelectedLocation().locationConfig.noOrdersBuyout) {
        if (ingredient.unit && cleverapps.unitsLibrary.isOpened(ingredient.unit)) {
            const type = Families[ingredient.unit.code].type;
            if (type.indexOf("order") !== -1 || type.indexOf("resource") !== -1) {
                price = ingredient.unit.stage === 3 ? 199 : 0;
            } else if (type.indexOf("fruit") !== -1) {
                price = 10;
            } else if (type.indexOf("product0") !== -1) {
                price = 20;
            } else if (type.indexOf("product1") !== -1) {
                price = 50;
            } else if (type.indexOf("product2") !== -1) {
                price = 125;
            } else if (type.indexOf("product3") !== -1) {
                price = 310;
            } else if (type.indexOf("product4") !== -1) {
                price = 775;
            }
        }

        if (ingredient.ingredient) {
            price = cleverapps.meta.getSelectedLocation().locationConfig.ingredientBuyoutPrice || 3;
        }
    }

    if (currency === "hard" && price > 0) {
        price = this.convertIngredientHardPrice(price);
    }

    return {
        currency,
        price
    };
};

CustomerRecipe.prototype.convertIngredientHardPrice = function (price) {
    return price;
};

CustomerRecipe.prototype.cookRecipe = function () {
    this.cooking = true;
};

CustomerRecipe.prototype.wasCooking = function () {
    return this.cooking;
};

CustomerRecipe.createRecipeTemplate = function (customer, recipeIndex, ignoreFilter) {
    let recipesConfig = CustomerRecipes[cleverapps.meta.selectedLocationId()];

    const unitType = customer.unit.getType();

    if (recipesConfig) {
        recipesConfig = recipesConfig[unitType] || recipesConfig[Unit.GetKey(customer.unit)];
    }

    if (!recipesConfig) {
        return;
    }

    if (recipesConfig[recipeIndex]) {
        recipesConfig = [recipesConfig[recipeIndex]];
    }

    if (ignoreFilter) {
        return PseudoRandom.GET().choose(recipesConfig);
    }

    if (unitType === "hero") {
        const recipeTemplate = CustomerRecipe.selectTemplateForOrdersWindow(customer, recipesConfig, recipeIndex);
        if (recipeTemplate && recipeTemplate.ingredients) {
            recipeTemplate.ingredients = CustomerRecipe.changeIngredientsWithAbundants(recipeTemplate.ingredients);
        }

        return recipeTemplate;
    }

    return CustomerRecipe.selectRecipeTemplateForCustomer(customer, recipesConfig);
};

CustomerRecipe.selectRecipeTemplateForCustomer = function (customer, recipesConfig) {
    const recipes = recipesConfig.filter((recipe) => {
        if (recipe.fog && !Map2d.currentMap.fogs.isOpened(recipe.fog)) {
            return false;
        }

        if (recipe.requiredUnits && !recipe.requiredUnits.every((unit) => cleverapps.unitsLibrary.isOpened(unit))) {
            return false;
        }

        if (recipe.opened && !recipe.ingredients.every((ingredient) => !ingredient.code || cleverapps.unitsLibrary.isOpened(ingredient))) {
            return false;
        }

        if (recipe.targetUnits && !recipe.targetUnits.every((target) => target.code && target.stage !== undefined && Map2d.currentMap.listAvailableUnits((unit) => unit.code === target.code && unit.stage === target.stage).length > 0)) {
            return false;
        }

        if (recipe.productAmount !== undefined && !recipe.order.every((product) => product.code && Map2d.currentMap.listAvailableUnits((unit) => unit.code === product.code && unit.stage === product.stage).length === recipe.productAmount)) {
            return false;
        }

        if (recipe.order && CustomerRecipe.isOrderProduceOnlyWhenNeeded(recipe.order)) {
            return CustomerRecipe.chooseIngredients(recipe.order).some((ingredient) => {
                const amount = Map2d.currentMap.customers.requiredIngredientAmount(ingredient);
                return amount && Map2d.currentMap.stock.getStockAmount(ingredient) < amount;
            });
        }

        if (recipe.oneTimeUse) {
            return CustomerRecipe.chooseIngredients(recipe.order).some((ingredient) => ingredient.unit && !cleverapps.unitsLibrary.isOpened(ingredient.unit));
        }

        return true;
    });

    return PseudoRandom.GET().choose(recipes);
};

CustomerRecipe.selectTemplateForOrdersWindow = function (customer, recipesConfig, recipeIndex) {
    const commonRecipes = [];

    recipesConfig.forEach((recipe) => {
        if (recipe.level > cleverapps.gameLevel.getLevel()) {
            return;
        }

        if (Map2d.currentMap.customers.listCustomers().some((curCustomer) => customer !== curCustomer && curCustomer.recipe && curCustomer.recipe.index === recipe.index)) {
            return;
        }

        if (recipe.index !== 0 && recipe.ingredients.every((ingredient) => cleverapps.unitsLibrary.hasOpened(ingredient.ingredient))) {
            commonRecipes.push(recipe);
        }
    });

    if (recipeIndex !== undefined) {
        return commonRecipes[0];
    }

    if (commonRecipes.length === 0 && cleverapps.gameLevel.getLevel() >= 1) {
        return CustomerRecipes.main[customer.unit.getType()][0];
    }

    if (commonRecipes.length <= 3) {
        return PseudoRandom.GET().choose(commonRecipes);
    }

    let id = commonRecipes.length - 1;
    while (id > 0 && PseudoRandom.GET().nextDouble() < 0.6) {
        id--;
    }
    return commonRecipes[id];
};

CustomerRecipe.chooseIngredients = function (template) {
    const availableCodes = {};
    const items = {};

    if (!template) {
        return [];
    }

    template.forEach((unitItem) => {
        if (unitItem.ingredient) {
            if (!items[unitItem.ingredient]) {
                items[unitItem.ingredient] = {
                    ingredient: unitItem.ingredient,
                    amount: 0
                };
            }

            items[unitItem.ingredient].amount += unitItem.amount;
            return;
        }

        let chosenCode;

        if (unitItem.code) {
            chosenCode = unitItem.code;
        } else if (unitItem.type) {
            if (!availableCodes[unitItem.type]) {
                availableCodes[unitItem.type] = {};
            }

            if (!availableCodes[unitItem.type][unitItem.stage] || availableCodes[unitItem.type][unitItem.stage].length === 0) {
                availableCodes[unitItem.type][unitItem.stage] = cleverapps.unitsLibrary.listOpenedOfType(unitItem.type);

                if (availableCodes[unitItem.type][unitItem.stage].length === 0) {
                    availableCodes[unitItem.type][unitItem.stage] = cleverapps.unitsLibrary.listCodesByType(unitItem.type).slice(0, 1);
                }
            }

            const codes = availableCodes[unitItem.type][unitItem.stage];

            chosenCode = PseudoRandom.GET().choose(codes);
            
            codes.splice(codes.indexOf(chosenCode), 1);
        }

        let chosenStage = unitItem.stage;
        if (unitItem.stages) {
            chosenStage = Math.min(Families[chosenCode].units.length - 1, PseudoRandom.GET().choose(unitItem.stages));
        }
        if (chosenStage === undefined) {
            chosenStage = Families[chosenCode].units.length - 1;
        }

        if (!items[`${chosenCode}_${chosenStage}`]) {
            items[`${chosenCode}_${chosenStage}`] = {
                unit: {
                    code: chosenCode,
                    stage: chosenStage
                },
                amount: 0
            };
        }

        items[`${chosenCode}_${chosenStage}`].amount += unitItem.amount;
    });

    return Object.values(items);
};

CustomerRecipe.changeIngredientsWithAbundants = function (ingredients) {
    const ingredientsNew = ingredients.slice();
    const ABUNDANCE_LIMIT = 80;
    const resources = Map2dLocation.currentLocation.harvested.listResources();
    const abundants = resources.filter(({ amount }) => amount >= ABUNDANCE_LIMIT).sort((a, b) => b.amount - a.amount);
    const notUsedAbundants = abundants.filter((item) => ingredientsNew.every((ingredient) => ingredient.ingredient !== item.ingredient));

    while (ingredientsNew.length < 3 && notUsedAbundants.length > 0) {
        ingredientsNew.push({ ...notUsedAbundants.shift(), amount: PseudoRandom.GET().choose([2, 3, 3, 4, 4, 5]) });
    }

    ingredientsNew.sort((a, b) => {
        const aAmount = Map2dLocation.currentLocation.harvested.get(a.ingredient) || 0;
        const bAmount = Map2dLocation.currentLocation.harvested.get(b.ingredient) || 0;
        return aAmount - bAmount;
    });

    for (let i = 0; i < ingredientsNew.length; i++) {
        if (notUsedAbundants.length === 0) {
            break;
        }

        const { ingredient, amount } = ingredientsNew[i];
        if (Map2dLocation.currentLocation.harvested.get(ingredient) >= ABUNDANCE_LIMIT) {
            continue;
        }
        ingredientsNew[i] = { ...notUsedAbundants.shift(), amount };
    }

    return PseudoRandom.GET().shuffle(ingredientsNew);
};

CustomerRecipe.getIngredientIcon = function (ingredient) {
    if (ingredient.ingredient) {
        return Map2dLocation.currentLocation.harvested.getIngredientIcon(ingredient.ingredient);
    }

    if (ingredient.unit) {
        return UnitView.getUnitImage(ingredient.unit, { preferStatic: true });
    }
};

CustomerRecipe.getIngredientName = function (ingredient) {
    if (ingredient.ingredient) {
        return Map2dLocation.currentLocation.harvested.getIngredientName(ingredient.ingredient);
    }

    if (ingredient.unit) {
        return cleverapps.unitsLibrary.getUnitName(ingredient.unit);
    }
};

CustomerRecipe.isOrderProduceOnlyWhenNeeded = function (order) {
    return order.some((product) => {
        if (product.stage === undefined) {
            return false;
        }

        const codes = product.code ? [product.code] : cleverapps.unitsLibrary.listCodesByType(product.type);

        return codes.some((code) => {
            const unit = Families[code] && Families[code].units[product.stage];
            const produceOnlyWhenNeeded = unit && unit.produceOnlyWhenNeeded;
            return produceOnlyWhenNeeded === true || (produceOnlyWhenNeeded && produceOnlyWhenNeeded[cleverapps.meta.selectedLocationId()] === true);
        });
    });
};

CustomerRecipe.isAcceptable = function (customer, recipe) {
    let recipesConfig = CustomerRecipes[cleverapps.meta.selectedLocationId()];

    const unitType = customer.unit.getType();

    if (recipesConfig) {
        recipesConfig = recipesConfig[unitType] || recipesConfig[Unit.GetKey(customer.unit)];
    }

    if (!recipesConfig) {
        return true;
    }

    for (const configKey of Object.keys(recipesConfig)) {
        const config = recipesConfig[configKey];
        const allMatch = config.ingredients.every((ingredient) => {
            if (ingredient.code) {
                return recipe.ingredients.some((ri) => ri.unit && ri.unit.code === ingredient.code && ri.unit.stage === ingredient.stage);
            }
            return true;
        });
        if (allMatch) {
            return true;
        }
    }

    return false;
};

CustomerRecipe.initialize = function () {
    Object.values(CustomerRecipes).forEach((expedition) => {
        Object.values(expedition).forEach((recipes) => {
            recipes.forEach((recipe, index) => {
                recipe.index = index;
            });
        });
    });
};

CustomerRecipe.encode = (recipe) => {
    const recipeItemEncoder = ({
        ingredient, unit, amount, code, stage, type
    }) => {
        if (ingredient) {
            return `${ingredient}*${amount}`;
        }
        if (unit) {
            return `${unit.code}_${unit.stage}*${amount}`;
        }
        if (type) {
            return `type_${type}_${stage}*${amount}`;
        }
        return `${code}_${stage}*${amount}`;
    };

    const encoded = {};

    if (recipe.ingredients) {
        encoded.i = recipe.ingredients.map(recipeItemEncoder);
    }
    if (recipe.order) {
        encoded.o = recipe.order.map(recipeItemEncoder);
    }
    if (recipe.cookingDuration) {
        encoded.d = Math.floor(recipe.cookingDuration / 1000);
    }

    return BareJSON.stringify(encoded);
};

CustomerRecipe.decode = (encoded) => {
    const recipeItemDecoder = (encodedItem) => {
        let [key, amount] = encodedItem.split("*");
        amount = parseInt(amount);

        if (key.startsWith("type_")) {
            key = key.slice(5).split("_");
            return { type: key[0], stage: parseInt(key[1]), amount };
        }

        key = key.split("_");

        if (key.length === 2) {
            return { code: key[0], stage: parseInt(key[1]), amount };
        }

        return { ingredient: key[0], amount };
    };

    const recipeItemFilter = (ingredient) => {
        if (ingredient.code) {
            return Families[ingredient.code] && Families[ingredient.code].units[ingredient.stage];
        }

        if (ingredient.type) {
            return cleverapps.unitsLibrary.listCodesByType(ingredient.type).length > 0;
        }

        if (ingredient.ingredient) {
            return Map2dLocation.currentLocation.harvested.isIngredientAvailable(ingredient.ingredient);
        }
    };

    encoded = BareJSON.parse(encoded);

    let ingredients = [], order = [];

    if (encoded.i) {
        ingredients = encoded.i.map(recipeItemDecoder).filter(recipeItemFilter);
    }

    if (encoded.o) {
        order = encoded.o.map(recipeItemDecoder).filter(recipeItemFilter);
    }

    return new CustomerRecipe({
        ingredients: ingredients.length ? ingredients : undefined,
        order: order.length ? order : undefined,
        cookingDuration: `${encoded.d || 0} seconds`
    });
};

const CustomerRecipes = {
    main: {}
};

CustomerRecipes.main = {
    hero: [
        {
            code: "icecream",
            level: 1,
            cookingDuration: "10 seconds",
            ingredients: [
                { ingredient: "wheat", amount: 2 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 }
            ]
        },
        {
            code: "cookies",
            level: 4,
            cookingDuration: "45 seconds",
            ingredients: [
                { ingredient: "candies", amount: 2 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "gingerbread",
            level: 4,
            cookingDuration: "90 seconds",
            ingredients: [
                { ingredient: "candies", amount: 2 },
                { ingredient: "wheat", amount: 3 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "croissant",
            level: 5,
            cookingDuration: "15 minutes",
            ingredients: [
                { ingredient: "candies", amount: 3 },
                { ingredient: "wheat", amount: 4 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 },
                { code: "wands", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "caramelpie",
            level: 6,
            cookingDuration: "5 minutes",
            ingredients: [
                { ingredient: "candies", amount: 2 },
                { ingredient: "wheat", amount: 2 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "bakedapple",
            level: 7,
            cookingDuration: "5 minutes",
            ingredients: [
                { ingredient: "apple", amount: 4 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "applejam",
            level: 7,
            cookingDuration: "15 minutes",
            ingredients: [
                { ingredient: "apple", amount: 5 },
                { ingredient: "wheat", amount: 2 }
            ],
            order: [
                { code: "wands", stage: 1, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "caramelapple",
            level: 8,
            cookingDuration: "10 minutes",
            ingredients: [
                { ingredient: "apple", amount: 4 },
                { ingredient: "wheat", amount: 2 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 },
                { code: "wands", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "applepie",
            level: 8,
            cookingDuration: "25 minutes",
            ingredients: [
                { ingredient: "candies", amount: 6 },
                { ingredient: "apple", amount: 2 },
                { ingredient: "wheat", amount: 2 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 },
                { code: "wands", stage: 1, amount: 1 },
                { code: "coins", stage: 1, amount: 1 }
            ]
        },
        {
            code: "strawberryjuice",
            level: 9,
            cookingDuration: "5 minutes",
            ingredients: [
                { ingredient: "strawberry", amount: 4 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "strawberrycake",
            level: 9,
            cookingDuration: "30 minutes",
            ingredients: [
                { ingredient: "candies", amount: 4 },
                { ingredient: "wheat", amount: 3 },
                { ingredient: "strawberry", amount: 5 }
            ],
            order: [
                { code: "wands", stage: 1, amount: 1 },
                { code: "wands", stage: 1, amount: 1 },
                { code: "coins", stage: 0, amount: 1 },
                { code: "coins", stage: 1, amount: 1 }
            ]
        },
        {
            code: "salad",
            level: 10,
            cookingDuration: "18 minutes",
            ingredients: [
                { ingredient: "candies", amount: 2 },
                { ingredient: "strawberry", amount: 6 }
            ],
            order: [
                { code: "wands", stage: 1, amount: 1 },
                { code: "coins", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "bubblegum",
            level: 11,
            cookingDuration: "20 minutes",
            ingredients: [
                { ingredient: "wheat", amount: 6 },
                { ingredient: "apple", amount: 3 }
            ],
            order: [
                { code: "wands", stage: 1, amount: 1 },
                { code: "coins", stage: 1, amount: 1 }
            ]
        },
        {
            code: "granola",
            level: 12,
            cookingDuration: "20 minutes",
            ingredients: [
                { ingredient: "candies", amount: 4 },
                { ingredient: "apple", amount: 5 }
            ],
            order: [
                { code: "wands", stage: 1, amount: 1 },
                { code: "coins", stage: 1, amount: 1 }
            ]
        },
        {
            code: "strawberrypie",
            level: 12,
            cookingDuration: "15 minutes",
            ingredients: [
                { ingredient: "strawberry", amount: 4 },
                { ingredient: "candies", amount: 3 }
            ],
            order: [
                { code: "wands", stage: 1, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "mushroomcnacks",
            level: 13,
            cookingDuration: "5 minutes",
            ingredients: [
                { ingredient: "mushrooms", amount: 2 },
                { ingredient: "wheat", amount: 3 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "mintcookies",
            level: 13,
            cookingDuration: "18 minutes",
            ingredients: [
                { ingredient: "mushrooms", amount: 2 },
                { ingredient: "candies", amount: 2 },
                { ingredient: "apple", amount: 3 }
            ],
            order: [
                { code: "wands", stage: 1, amount: 1 },
                { code: "coins", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "stage18",
            level: 14,
            cookingDuration: "30 minutes",
            ingredients: [
                { ingredient: "wheat", amount: 4 },
                { ingredient: "apple", amount: 3 },
                { ingredient: "strawberry", amount: 2 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 },
                { code: "wands", stage: 1, amount: 1 },
                { code: "coins", stage: 1, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "stage19",
            level: 15,
            cookingDuration: "15 minutes",
            ingredients: [
                { ingredient: "mushrooms", amount: 2 },
                { ingredient: "strawberry", amount: 2 },
                { ingredient: "apple", amount: 2 }
            ],
            order: [
                { code: "wands", stage: 1, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        },
        {
            code: "stage20",
            level: 16,
            cookingDuration: "20 minutes",
            ingredients: [
                { ingredient: "mushrooms", amount: 2 },
                { ingredient: "candies", amount: 3 },
                { ingredient: "corn", amount: 4 }
            ],
            order: [
                { code: "wands", stage: 0, amount: 1 },
                { code: "wands", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 },
                { code: "coins", stage: 0, amount: 1 }
            ]
        }
    ]
};